/* globals angular, _ */
(function() {
  'use strict';

  function ReversesDeliveryFilterCtrl (
    mdPanelRef,
    moment,
    localStorageService
  ) {
    var ctrl = this;
    ctrl.startDate = ctrl.filters.data &&
      ctrl.filters.data.dataEntregaPrevistaInicio ||
      null;
    ctrl.endDate = ctrl.filters.data &&
      ctrl.filters.data.dataEntregaPrevistaFim ||
      null;
    ctrl.checkbox = {
      inTime: ctrl.filters.data && ctrl.filters.data.noPrazo,
      delayed: ctrl.filters.data && ctrl.filters.data.atrasada,
    };
    ctrl.close = function () {
      mdPanelRef.close();
    };
    ctrl.clearFields = function () {
      ctrl.filters.data = {
        dataEntregaPrevistaInicio: ctrl.startDate = null,
        dataEntregaPrevistaFim: ctrl.endDate = null,
        noPrazo: ctrl.checkbox.inTime = false,
        delayed: ctrl.checkbox.delayed = false,
      };
      ctrl.close();
    };
    ctrl.onSubmit = function (form) {
      if (form.$pristine) {
        ctrl.close();
        return;
      }
      var diff = _.filter(form.$$controls, {'$dirty': true});
      if (!ctrl.filters.data) {
        ctrl.filters.data = {};
      }
      _.forEach(diff, function(field){
        if (
          field.$name === 'dataEntregaPrevistaFim' ||
          field.$name === 'dataEntregaPrevistaInicio'
        ) {
          field.$modelValue = moment(field.$modelValue).format('YYYY/MM/DD');
        }
        ctrl.filters.data[field.$name] = field.$modelValue;
      });
      var actionName, actionValue;
      if (ctrl.filters.data.noPrazo) {
        actionName = 'FilterSituationOnTime';
        actionValue = true;
      } else if (ctrl.filters.data.atrasada) {
        actionName = 'FilterSituationLater';
        actionValue = true;
      }
      if (
          ctrl.filters.data.dataEntregaPrevistaInicio ||
          ctrl.filters.data.dataEntregaPrevistaFim
        ) {
        actionName = 'FilterDeliveryDate';
        actionValue = ctrl.filters.data.dataEntregaPrevistaInicio + ' - '
          + ctrl.filters.data.dataEntregaPrevistaFim;
      }
      ctrl.close();
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReversesDeliveryFilterCtrl', ReversesDeliveryFilterCtrl);
}());
